<template>
  <van-nav-bar
    title="公告详情"
    fixed
    placeholder
    left-text="返回"
    left-arrow
    @click-left="goBack"
  />

  <div
    class="
      mx-2
      mt-1
      overflow-y-auto
      h-72
      p-1
      filter
      drop-shadow-md
      rounded-sm
      bg-white
    "
  >
    <div class="small-text" v-html="content" />
  </div>
</template>

<script>
import { reactive, onMounted, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getNoticeDetail } from "@/service/home";
import {Toast} from "vant";
export default {
  name: "home",
  components: {},
  setup() {
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      content: "",
    });
    const goBack = () => router.go(-1);

    const unEscapeHTML = (html) => {
      return html
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&amp;/g, "&")
        .replace(/&quot;/g, '"')
        .replace(/&apos;/g, "'");
    };
    onMounted(async () => {
      try {
        const { data } = await getNoticeDetail(route.params.id);
        const noticeData = data;
        state.content = unEscapeHTML(noticeData[0].content);
      } catch (error) {
        Toast.fail(error.message);
      }
    });
    return {
      ...toRefs(state),
      goBack,
    };
  },
};
</script>

<style lang="less" scoped>
.desc {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
</style>
